import React, { 
  useEffect, 
  useState 
} from 'react'
import { I18n } from 'react-redux-i18n'
import { connect, 
  useDispatch, 
  useSelector 
} from 'react-redux'
import { withRouter } from 'react-router-dom'

import { campaignsUpdateFilters, campaignsUpdateSearchText, getFilters } from 'redux/actions/marketing'
import { getOperators } from 'redux/actions/operators'
import { MARKETING } from 'constants/index'
import SearchFilters from 'components/SearchFilters'

const Filters = (props) => {
  const { marketing } = props
  const dispatch = useDispatch()
  const company = useSelector((store) => store.companies)
  const operators = useSelector((store) => store.operators)
  const [iconFilter, setIconFilter] = useState('off')
  const [operatorOptions, setOperatorOptions] = useState([])
  const [filters, setFilters] = useState({})
  const [filtersFetched, setFiltersFetched] = useState(false)

  // Get all operators
  useEffect(() => {
    dispatch(getOperators({ idCompany: company._id }))
  }, [dispatch, company])
  useEffect(() => {
    if (Object.values(operators).length > 0) {
      const ops = [].concat(
        Object.values(operators).map((op, i) => ({
          value: op._id,
          label: `${op.name || ''} ${op.lastname || ''}`.trim(),
        }))
      )
      setOperatorOptions(ops)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operators])

  // Get filters
  useEffect(() => {
    // get all filters
    dispatch(getFilters())
      .then((data) => {
        setFilters(data)
        setFiltersFetched(true)
      })
      .catch(console.error)
    return () => {
      setFilters({})
      setFiltersFetched(false)
    }

  }, [dispatch])

  useEffect(() => {
    setIconFilter(iconFilterOff())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketing])

  const iconFilterOff = () => {
    for (const field of MARKETING.searchFilterCampaign ) {
      const typeOfField = typeof marketing[field]
      if(typeOfField !== 'string' && typeOfField !== 'number'){
        if(marketing[field].length !== MARKETING.fieldsFiltersCampaign[field].default.length) return 'on'
        if(MARKETING.fieldsFiltersCampaign[field].type === 'date'){
          for(const dateFilter of marketing[field]){
            if(dateFilter !== '') return 'on'
          }
        }
      }
      else if( marketing[field] !== MARKETING.fieldsFiltersCampaign[field].default) return 'on'
    }
    return 'off'
  }

  const states = [].concat(
    Object.keys(MARKETING.status).map((key, i) => ({
      value: key,
      label: I18n.t(MARKETING.status[key] || ''),
    }))
  )
  const channelOptions = filtersFetched ? filters.channels.map(channel => ({ ...channel, label: I18n.t(`channels_${channel.value}`) })) : []

  const handleSelectChange = (value, field) => {
    if(field === 'textToSearch' || field === 'name'){
      dispatch(campaignsUpdateSearchText(field, value))
      return
    }
    dispatch(campaignsUpdateFilters([field], value))
  }

  const resetFilters = async () => {
    Promise.all([
      dispatch(campaignsUpdateFilters('textToSearch', '', false)),
      dispatch(campaignsUpdateFilters('limit', 30, false)),
      dispatch(campaignsUpdateFilters('name', '', false)),
      dispatch(campaignsUpdateFilters('states', [], false)),
      dispatch(campaignsUpdateFilters('channels', [], false)),
      dispatch(campaignsUpdateFilters('operators', [], false)),
      dispatch(campaignsUpdateFilters(['createdAt'], ['', ''], false)),
      dispatch(campaignsUpdateFilters(['startDate'], ['', ''], false)),
      dispatch(campaignsUpdateFilters(['endDate'], ['', ''], false)),
      dispatch(campaignsUpdateFilters('sortType', MARKETING.sortInit.sortType, false)),
      dispatch(campaignsUpdateFilters('sortByField', MARKETING.sortInit.sortByField))
    ]).catch(console.error)
  }

  const getFieldsFilter =()=>{
    return{
      ...MARKETING.fieldsFiltersCampaign,
      operators: {
        ...MARKETING.fieldsFiltersCampaign.operators,
        options: operatorOptions.filter(value => value.label)
      },
      states: {
        ...MARKETING.fieldsFiltersCampaign.states,
        options: states
      },
      channels: {
        ...MARKETING.fieldsFiltersCampaign.channels,
        options: channelOptions
      }
    }
  }

  return (
    <div className='campaign-left-filters'>
      <SearchFilters
        fieldsFilter={getFieldsFilter()}
        searchFilter={MARKETING.searchFilterCampaign}
        valueFilters={marketing}
        delegations={[]}
        brands={[]}
        handleOnChange={(value, field)=>{handleSelectChange(value, field)}}
        resetFilters={resetFilters}
        statusIconFilter={iconFilter}
      />
    </div>
  )
}

export default connect((state) => ({
  marketing: state.marketing,
}))(withRouter(Filters))
